import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../_dashboard/helpers'
import {useNavigate} from 'react-router-dom'
import dataAxios from '../../../../modules/auth/core/dataAxios'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {buildToursListQuery} from '../core/buildToursListQuery'

const API_URL = process.env.REACT_APP_API_URL || ''

const apiBase = () => (API_URL || '').replace(/\/api\/?$/i, '')

const ToursListToolbar = () => {
  const navigate = useNavigate()
  const intl = useIntl()
  const {state} = useQueryRequest()

  const openAddTourModal = () => {
    navigate('/apps/tours/new')
  }

  const runExport = async (exportAs: 'excel' | 'csv') => {
    try {
      const exportParams = buildToursListQuery(state)
      const res = await dataAxios.get(`${API_URL.replace(/\/$/, '')}/export`, {
        params: {dataType: 'tours', exportAs, ...exportParams},
      })
      const raw = res.data?.data?.url as string | undefined
      if (!raw) {
        return
      }
      const rel = raw.replace(/^\.\//, '')
      window.open(`${apiBase()}/${rel}`, '_blank', 'noopener,noreferrer')
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='d-flex flex-wrap gap-2 justify-content-end' data-kt-tour-table-toolbar='base'>
      <button type='button' className='btn btn-light-primary btn-sm' onClick={() => runExport('csv')}>
        {intl.formatMessage({id: 'USERS.EXPORT.CSV'})}
      </button>
      <button type='button' className='btn btn-light-primary btn-sm' onClick={() => runExport('excel')}>
        {intl.formatMessage({id: 'USERS.EXPORT.EXCEL'})}
      </button>
      <button type='button' className='btn btn-primary btn-sm' onClick={openAddTourModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        {intl.formatMessage({id: 'TOUR.ADD'})}
      </button>
    </div>
  )
}

export {ToursListToolbar}
